import { combineReducers } from "redux";
import { ModalReducer as modal } from "./modal";
import { SideNavReducer as sideNav } from "./sideNav";

export default combineReducers({
  modal,
  sideNav,
});
